"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _useStyles = _interopRequireDefault(require("./useStyles"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Element = function Element(_ref) {
  var alt = _ref.alt,
      src = _ref.src,
      subtitle1 = _ref.subtitle1,
      subtitle2 = _ref.subtitle2,
      body = _ref.body,
      isFirst = _ref.isFirst;
  var classes = (0, _useStyles["default"])();
  var classNames = isFirst ? "".concat(classes.listWrapper, " ").concat(classes.first) : classes.listWrapper;
  return /*#__PURE__*/_react["default"].createElement(_core.ListItem, {
    className: classNames
  }, alt && src && isFirst ? /*#__PURE__*/_react["default"].createElement(_core.ListItemAvatar, null, /*#__PURE__*/_react["default"].createElement(_core.Avatar, {
    className: classes.avatarImg,
    alt: alt,
    src: src
  })) : null, /*#__PURE__*/_react["default"].createElement(_core.Box, null, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    "aria-hidden": true,
    variant: "subtitle1",
    className: classes.subtitle1,
    component: "span"
  }, subtitle1), /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: "subtitle2",
    className: classes.subtitle2,
    component: "h4"
  }, subtitle2), /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: "body1",
    className: classes.body1
  }, body)));
};

Element.defaultProps = {
  alt: '',
  src: '',
  isFirst: false
};
Element.propTypes = {
  alt: _propTypes["default"].string,
  src: _propTypes["default"].string,
  subtitle1: _propTypes["default"].string.isRequired,
  subtitle2: _propTypes["default"].string.isRequired,
  body: _propTypes["default"].string.isRequired,
  isFirst: _propTypes["default"].bool
};
var _default = Element;
exports["default"] = _default;